import { logError } from '@/redux/util';
import axios from 'axios';
import config from '../../config';
import { getHeaders } from 'utils';

export const fetchAIPhotobooths = aiPhotobooths => ({
	type: 'FETCH_AI_PHOTOBOOTHS',
	payload: aiPhotobooths,
});
export const addAIPhotobooth = aiPhotobooth => ({
	type: 'ADD_AI_PHOTOBOOTH',
	payload: aiPhotobooth,
});
export const deleteAIPhotobooth = pbID => ({
	type: 'DELETE_AI_PHOTOBOOTH',
	payload: pbID,
});

export const thunkFetchPhotobooths = eventID => async dispatch => {
	const url = `${config.aiPhotoBoothServerUrl}/api/admin/photobooths/${eventID}`;
	try {
		const response = await axios.get(url, { ...getHeaders() });
		dispatch(fetchAIPhotobooths(response.data));
	} catch (error) {
		logError(error, 'aiPhotobooth.actions.thunkFetchPhotobooths');
	}
};

export const thunkCreatePhotobooth = (eventID, values) => async dispatch => {
	const url = `${config.aiPhotoBoothServerUrl}/api/admin/photobooths/${eventID}`;
	try {
		const response = await axios.post(url, values, { ...getHeaders() });
		dispatch(addAIPhotobooth(response.data));
	} catch (error) {
		logError(error, 'aiPhotobooth.actions.thunkCreatePhotobooth');
	}
};

export const thunkDeletePhotobooth = (eventID, pbId) => async dispatch => {
	const url = `${config.aiPhotoBoothServerUrl}/api/admin/photobooths/${eventID}/${pbId}`;
	try {
		const response = await axios.delete(url, { ...getHeaders() });
		dispatch(deleteAIPhotobooth(response.data));
	} catch (error) {
		logError(error, 'aiPhotobooth.actions.thunkDeletePhotobooth');
	}
};
